import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { LegalPageLayoutComponent, LegalSection } from '../../../components/legal/legal-page-layout/legal-page-layout';

@Component({
  selector: 'app-terms-of-service',
  standalone: true,
  imports: [LegalPageLayoutComponent, RouterLink],
  templateUrl: './terms-of-service.html',
})
export class TermsOfService {
  sections: LegalSection[] = [
    { id: 'account-registration', label: 'Account Registration and Eligibility' },
    { id: 'acceptable-use', label: 'Acceptable Use' },
    { id: 'user-generated-content', label: 'User-Generated Content and Creator Responsibilities' },
    { id: 'intellectual-property', label: 'Intellectual Property (Platform and Trade Marks)' },
    { id: 'termination-suspension', label: 'Termination and Suspension of Accounts' },
    { id: 'disclaimers', label: 'Disclaimers' },
    { id: 'limitation-of-liability', label: 'Limitation of Liability' },
    { id: 'governing-law', label: 'Governing Law and Jurisdiction' },
    { id: 'dispute-resolution', label: 'Dispute Resolution' },
  ];
}
